import psl, { ParsedDomain } from 'psl';
import { Capacitor } from '@capacitor/core';
import { REALM_SWEDEN, REALM_UK } from './realms';

/**
 * https://stackoverflow.com/a/27434991
 * @param host
 */
const isNetworkIp = (host: string) =>
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
    host,
  );

export const UNKNOWN_REALM = 'unknown';
export const getBrowserRealm = (): string => {
  const defaultLocalEnvRealm = REALM_SWEDEN;

  const host: string = window.location.hostname;
  if (host.endsWith('cloud')) {
    // External call in test
    const match = host.match(/(\w+)(?=\.dev.ilt.cloud)/);
    return match ? match[0] : UNKNOWN_REALM;
  }

  if (host.startsWith('localhost') && !Capacitor.isNativePlatform()) {
    // Internal local call
    return defaultLocalEnvRealm;
  }

  /*
  For running the application on another connected device, serving local files.
   */
  if (isNetworkIp(host)) {
    return defaultLocalEnvRealm;
  }

  if (host.endsWith('gigletsedu.com')) {
    return 'uk';
  }

  const { tld } = psl.parse(host) as ParsedDomain;
  if (!tld) return UNKNOWN_REALM;

  switch (tld) {
    case 'co.uk':
      return REALM_UK;
    case 'com':
      return 'us';
    default:
      return tld;
  }
};
